import { APP_STUDENT, APP_TEACHER } from 'voxguru-v1/utils/constants';

const getCurrentUserType = () =>
  process.env.REACT_APP_USER_ENVIRONMENT === APP_TEACHER
    ? APP_TEACHER
    : APP_STUDENT;

export default getCurrentUserType;
